import { useEffect, useState } from "react";
import { Menu, X, Heart } from "lucide-react";
import { useDonation } from "@/context/DonationContext";

const LINKS = [
  { href: "#pilar-cristao", label: "Cristão" },
  { href: "#pilar-saude", label: "Saúde" },
  { href: "#outros-pilares", label: "Projetos" },
  { href: "#momentos", label: "Momentos" },
  { href: "#instagram", label: "Instagram" },
  { href: "#localizacao", label: "Localização" },
  { href: "#contato", label: "Contato" },
];

export default function Navbar() {
  const { openModal } = useDonation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="ga-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "py-2" : "py-4"}`}
    >
      <div className="container-ga">
        <div
          className={`flex items-center justify-between rounded-full px-4 sm:px-6 py-3 transition-all duration-500 ${
            scrolled
              ? "glass border border-border shadow-[0_10px_40px_-20px_rgba(15,23,42,0.25)]"
              : "bg-white/10 border border-white/20 backdrop-blur-md"
          }`}
        >
          <a href="#top" data-testid="ga-logo" className="flex items-center gap-2 group" aria-label="Instituto">
            <span className="relative inline-flex items-center justify-center w-10 h-10 rounded-2xl bg-ga-ink text-white font-display font-black text-lg tracking-tight shadow-lg">
              GA<span className="text-ga-emerald">+</span>
            </span>
            <span
              className={`font-display font-extrabold text-lg tracking-tight transition-colors ${
                scrolled ? "text-ga-ink" : "text-white drop-shadow"
              }`}
            >
              Instituto
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                  scrolled
                    ? "text-ga-ink/70 hover:text-ga-ink hover:bg-ga-ink/5"
                    : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <button
              type="button"
              onClick={() => openModal("navbar")}
              data-testid="nav-donate-btn"
              className="inline-flex items-center gap-2 rounded-full bg-ga-emerald text-white px-5 py-2.5 text-sm font-bold hover:bg-ga-emerald_deep transition-colors shadow-lg"
            >
              <Heart className="w-4 h-4" /> Doar
            </button>
          </div>

          <button
            type="button"
            className={`lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full ${
              scrolled ? "bg-ga-ink text-white" : "bg-white/20 text-white"
            }`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Abrir menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <div
            className="lg:hidden mt-2 rounded-3xl bg-white border border-border shadow-xl p-4 space-y-1"
            data-testid="nav-mobile-menu"
          >
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="block px-4 py-3 rounded-2xl text-ga-ink font-semibold hover:bg-ga-ink/5"
              >
                {l.label}
              </a>
            ))}
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                openModal("navbar-mobile");
              }}
              className="mt-1 flex items-center justify-center gap-2 w-full btn-primary"
              data-testid="nav-mobile-donate"
            >
              <Heart className="w-4 h-4" /> Doar agora
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
